import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AtomsLibraryComponent } from './atoms-library.component';
import { ButtonComponent } from './atoms/button/button.component';
import { IconComponent } from './atoms/icon/icon.component';
import { SpriteIconsComponent } from './sprite-icons/sprite-icons.component';
import { MenuListComponent } from './molecules/menu-list/menu-list.component';
import { InputComponent } from './atoms/input/input.component';
import { PasswordStrengthBarComponent } from './atoms/password-strength-bar/password-strength-bar.component';
import { LabelComponent } from './atoms/labels/label.component';
import { TabComponent } from './molecules/tabs/tab/tab.component';
import { TabGroupComponent } from './molecules/tabs/tab-group/tab-group.component';
import { ModalComponent } from './molecules/modal/modal.component';
import { RadioButtonComponent } from './atoms/radio-button/radio-button.component';
import { TextAreaComponent } from './atoms/text-area/text-area.component';
import { ToggleButtonComponent } from './atoms/toggle-button/toggle-button.component';
import { CheckboxComponent } from './atoms/checkbox/checkbox.component';

@NgModule({
  declarations: [
    AtomsLibraryComponent,
    ButtonComponent,
    IconComponent,
    SpriteIconsComponent,
    MenuListComponent,
    InputComponent,
    PasswordStrengthBarComponent,
    LabelComponent,
    TabComponent,
    TabGroupComponent,
    ModalComponent,
    RadioButtonComponent,
    TextAreaComponent,
    ToggleButtonComponent,
    CheckboxComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    AtomsLibraryComponent,
    ButtonComponent,
    IconComponent,
    SpriteIconsComponent,
    MenuListComponent,
    InputComponent,
    PasswordStrengthBarComponent,
    LabelComponent,
    TabComponent,
    TabGroupComponent,
    ModalComponent,
    RadioButtonComponent,
    TextAreaComponent,
    ToggleButtonComponent,
    CheckboxComponent
  ]
})
export class AtomsLibraryModule { }
